(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDeleteController',Qsched_typeDeleteController);

    Qsched_typeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_type'];

    function Qsched_typeDeleteController($uibModalInstance, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
